import { render, staticRenderFns } from "./SeniorDetail.vue?vue&type=template&id=103508a0&scoped=true"
import script from "./SeniorDetail.vue?vue&type=script&lang=js"
export * from "./SeniorDetail.vue?vue&type=script&lang=js"
import style0 from "./SeniorDetail.vue?vue&type=style&index=0&id=103508a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103508a0",
  null
  
)

export default component.exports